import React, { useEffect, useRef } from 'react';
import { keys } from 'lodash';
import Popup from '../Popup';
import type { IPaylatePopupProps } from './types';
import { PAYLATE_POPUP_TEST_ID, PAYLATE_FORM_TEST_ID } from './constants';
import { getFormValue } from './utils';

const popupCls = 'lt-paylate-popup';

const popupClassNames = {
  modal: popupCls,
  closeButton: 'lt-modal-popup__close',
  overlay: `${popupCls}__overlay`,
};

export const PaylatePopup: React.FC<IPaylatePopupProps> = ({
  paylateData,
  goToOrderPage,
}) => {
  const formRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    if (paylateData && formRef.current) {
      formRef.current.submit();
    }
  }, [paylateData]);

  if (!paylateData) {
    return null;
  }

  const { redirect, name, data } = paylateData;

  return (
    <Popup
      classNames={popupClassNames}
      open
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={goToOrderPage}
      data-testid={PAYLATE_POPUP_TEST_ID}
    >
      <form
        target={data.order_id}
        action={redirect}
        method="post"
        ref={formRef}
        data-testid={PAYLATE_FORM_TEST_ID}
      >
        {keys(data).map((key) => (
          <input
            type="hidden"
            key={key}
            name={key}
            value={getFormValue(data[key])}
            data-testid={`${PAYLATE_FORM_TEST_ID}-${key}`}
          />
        ))}
      </form>
      <iframe name={data.order_id} title={name} width="100%" height="100%" />
    </Popup>
  );
};
